export default "__VITE_ASSET__6ulKm7pM__"